import { useMemo } from "react"
import { useSelector } from "react-redux"
import { detectAccountHolder } from "@/utils"

const useTopRoleIsAccountHolder = (userData) => {
    const userRoleData = useSelector((state) => state.userRoleReducer)
    const { user } = userData // signed up user
    const { userRolesArray } = userRoleData // signed up user role

    const loginUserRoles = useMemo(() => {
        if (userRolesArray.length) {
            const rolesTarget = userRolesArray.find((userRoleItem) => userRoleItem.userId === user.userId)
            if (rolesTarget && rolesTarget.userRoles) return rolesTarget.userRoles
        }
        return null
    }, [userRolesArray])

    const topRoleIsAccountHolder = useMemo(() => loginUserRoles && detectAccountHolder(loginUserRoles), [userRolesArray])

    return topRoleIsAccountHolder
}

export default useTopRoleIsAccountHolder
